import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../store/features/auth/authApi";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Card, Container, Form } from "react-bootstrap";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Please confirm your password"),
});

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const res = await resetPassword(token, values.password);
      toast.success("Your password has been reset successfully. Please log in to continue.");
      resetForm();
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error resetting password");
    } finally {
      setSubmitting(false);
    }
  };

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card style={{ width: "100%", maxWidth: "400px" }} className="p-4 shadow">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
          alt="abarka-logo"
          className="login-logo"
        />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            handleChange,
            handleSubmit,
            touched,
            errors,
            isSubmitting,
          }) => (
            <Form onSubmit={handleSubmit}>
              {/* Password field */}
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  isInvalid={touched.password && errors.password}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Confirm Password field */}
              <Form.Group className="mb-3">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  isInvalid={touched.confirmPassword && errors.confirmPassword}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group>

              <Button
                type="submit"
                className="w-100"
                variant="primary"
                disabled={isSubmitting}
              >
                Reset Password
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Container>
  );
};

export default ResetPassword;
